export default {
  common: {
    esg: {
      category: 'หมวดหมู่',
      environment: 'สภาพแวดล้อม',
      society: 'โซเชียล',
      governance: 'ธรรมาภิบาล',
      other: 'อื่น ๆ',
      comprehensive: 'ผลรวม',
      // basic: '',
    },
    btn: {
      cancel: 'ยกเลิก',
      add: 'เพิ่ม',
      create: 'สร้าง',
      update: 'อัปเดต',
      apply: 'ใช้',
      close: 'ปิด',
      create_new: 'สร้างใหม่',
      edit: 'แก้ไข',
      detail: 'รายละเอียด',
      view_detail: 'รายละเอียด',
      delete: 'ลบ',
      change: 'เปลี่ยนแปลง',
      confirm: 'ยืนยัน',
      clear: 'rรีเซ็ต',
      download: 'ดาวน์โหลด',
      save: 'บันทึก',
      register: 'ลงทะเบียน',
      check_answer: 'ตรวจคำตอบ',
      score_card_list: 'รายการสกอร์การ์ด',
      confirm_action: '@:common.btn.confirm',
      edit_action: '@:common.btn.edit',
      create_action: '@:common.btn.create',
      add_action: '@:common.btn.add',
      bulk_download: 'ดาวน์โหลดจำนวนมาก',
    },
    link: {
      delete: 'ลบ',
      back: 'กลับสู่',
    },
    sentence: {
      back_to_login: 'กลับสู่การเข้าสู่ระบบ',
      back_to_dashboard: 'กลับไปที่แผงหน้าปัด',
      not_applicable: 'ไม่สามารถใช้ได้*',
      // back_to_top: '',
    },
    switch: {
      current_language: 'Language',
    },
    filter: {
      questionnaire: 'แบบสอบถาม',
      questionnaire_short: '@:common.filter.questionnaire',
      target_questionnaire: 'เลือกแบบสอบถาม',
      target_year: 'ปี',
      target_year_text: 'เลือกปี',
      target_company: 'บริษัท',
      target_company_text: 'เลือกบริษัท',
      total: 'ทั้งหมด: {total}',
    },
    label: {
      required: 'จำเป็น',
      optional: 'เป็นทางเลือก',
      year: 'ปี',
    },
    form: {
      search_word: {
        label: 'ค้นหาคำศัพท์ฟรี',
        placeholder: '@:common.placeholder.input_free',
      },
    },
    date: {
      dateFormatTemp: 'dd/MM/yyyy',
      dateTimeFormatTemp: 'dd/MM/yyyy HH:mm zzz',
      datePickerFormat: 'dd/MM/yyyy',
      datePickerPlaceholder: 'DD/MM/YYYY',
      issue_date: 'วันที่ออก',
      evaluation_expires_date: 'วันที่มีผลบังคับใช้',
      answer_expires_date: 'กำหนดเส้นตาย',
      // last_updated_date: '',
    },
    error: {
      code_0005: 'ตรวจสอบสิทธิ์ไม่สำเร็จ โปรดเข้าสู่ระบบอีกครั้ง',
      code_0007: 'คำถามนี้จำเป็น',
      code_5001: 'ไม่พบหน้า',
      code_0001: 'ส่งแบบสอบถามล่าสุดแล้ว',
      code_0002: 'การอัปเดตล้มเหลวเนื่องจากมีการอัปเดตข้อมูลล่าสุดจากอุปกรณ์อื่น โปรดโหลดซ้ำแล้วลองอัปเดตอีกครั้ง',
      code_0003: 'ลบไฟล์ไม่สำเร็จ โปรดลบหลังจากตอบคำถามอย่างน้อยหนึ่งข้อ',
      code_0006: 'ผู้ใช้รายนี้ลงทะเบียนแล้ว',
      code_0004: 'ไฟล์นี้เกินขนาดไฟล์ที่อัปโหลดได้ โปรดทราบว่าขนาดจะต้องไม่เกิน 50MB',
      code_9999: 'เกิดข้อผิดพลาดที่ไม่คาดคิด',
    },
    evaluation: {
      title: 'ร้องขอการประเมิน',
      dashboard: 'แผงหน้าปัด',
      analysis: 'การวิเคราะห์',
      list: 'รายชื่อบริษัท',
    },
    dashboard: {
      title: 'แผงหน้าปัด',
    },
    upload: {
      title: 'แบบสอบถาม',
      common: 'ทั่วไป',
    },
    scorecard: {
      title: 'บัตรคะแนน',
      list: 'รายการ',
      detail: 'รายละเอียด',
      scorecard_detail: 'รายละเอียดของสกอร์การ์ด',
      answer_preview: 'ดูตัวอย่างคำตอบ',
      // breadcrumb_detail: '',
    },
    improvementplans: {
      title: 'แผนการปรับปรุง',
      detail: '@:common.scorecard.detail',
      // breadcrumb_detail: '',
    },
    detailExtra: {
      title: 'การวิเคราะห์เพิ่มเติม',
    },
    settings: {
      title: 'การตั้งค่า',
    },
    // default_selector: {
    //   selected_label: '',
    //   do_select:      '',
    //   do_release:     '',
    // },
    contact: {
      title: 'คำถามที่พบบ่อย',
    },
    logout: {
      title: 'ออกจากระบบ',
    },
    industry: {
      type_1: 'เกษตรกรรม การป่าไม้ และการประมง',
      type_2: 'การทำเหมืองแร่ เหมืองหิน และการแยกหินกรวด',
      type_3: 'อุตสาหกรรมการก่อสร้าง (รวมถึงการก่อสร้างสิ่งอำนวยความสะดวก)',
      type_4: 'อุตสาหกรรมการผลิต (เหล็ก เหล็กกล้า โลหะที่ไม่ใช่เหล็ก ผลิตภัณฑ์โลหะ)',
      type_5: 'อุตสาหกรรมการผลิต (เครื่องจักร อุปกรณ์ อิเล็กทรอนิกส์ ฯลฯ)',
      type_6: 'อุตสาหกรรมการผลิต (อาหาร เครื่องดื่ม ยาสูบ ฯลฯ)',
      type_7: 'อุตสาหกรรมการผลิต (เยื่อกระดาษ กระดาษ ผลิตภัณฑ์กระดาษ)',
      type_8: 'อุตสาหกรรมการผลิต (ไม้ การแปรรูปผลิตภัณฑ์จากไม้)',
      type_9: 'อุตสาหกรรมการผลิต (อุตสาหกรรมเคมี รวมถึงยา อุตสาหกรรมสิ่งทอ)',
      type_10: 'อุตสาหกรรมการผลิต (ปิโตรเลียม ถ่านหิน ยาง พลาสติก ฯลฯ)',
      type_11: 'อุตสาหกรรมการผลิต (อุตสาหกรรมการพิมพ์)',
      type_12: 'อุตสาหกรรม/การผลิต (อื่น ๆ)',
      type_13: 'แหล่งจ่ายไฟ ก๊าซ ความร้อน',
      type_14: 'โทรคมนาคม',
      type_15: 'อุตสาหกรรมการขนส่งและคลังสินค้า',
      type_16: 'อุตสาหกรรมการค้าส่งและค้าปลีก',
      type_17: 'อุตสาหกรรมการเงินและการประกันภัย',
      type_18: 'อุตสาหกรรมอสังหาริมทรัพย์',
      type_19: 'โรงเรียน (รวมถึงโรงเรียนอนุบาลและศูนย์รับเลี้ยงเด็ก)',
      type_20: 'อุตสาหกรรมบริการที่พักและอาหาร',
      type_21: 'อุตสาหกรรมบริการที่เกี่ยวข้องกับชีวิต (ร้านซักรีด ร้านตัดผม ความงาม โรงอาบน้ำ ฯลฯ)',
      type_22: 'อุตสาหกรรมการแพทย์และสวัสดิการ',
      type_23: 'อุตสาหกรรมการกำจัดขยะและการรีไซเคิล',
      type_24: 'อุตสาหกรรมการบำรุงรักษารถยนต์',
      type_25: 'รัฐบาลท้องถิ่น หน่วยงานสาธารณะ ฯลฯ',
      type_26: 'อื่น ๆ',
    },
    scale: {
      a: '1〜29 คน',
      b: '30〜99 คน',
      c: '100〜499 คน',
      d: '500〜999 คน',
      e: '1000〜4999 คน',
      f: 'มากกว่า 5,000 คน',
    },
    sales_amount: {
      under_1million: '~1 ล้านเหรียญสหรัฐ',
      under_10million: '1~10 ล้านเหรียญสหรัฐ',
      under_100million: '10~100 ล้านเหรียญสหรัฐ',
      under_1billion: '100 ล้าน~1 พันล้านเหรียญสหรัฐ',
      under_10billion: '1~10 พันล้านเหรียญสหรัฐ',
      over_10billion: '10 พันล้านเหรียญสหรัฐ',
      not_disclose: 'ไม่ประสงค์จะเปิดเผย',
    },
    progress: 'ความคืบหน้า',
    url: {
      contact: 'https://asuene.com/rating/en/form/contact',
      asuene: 'https://asuene.com/apac',
      asuene_lca: '---ja のみ表示---',
      asuene_career: 'https://asuene.com/career/biz',
      corporate: 'https://corp.asuene.com/en',
    },
    head_title: 'ASUENE ESG',
    company_name_inc: 'ASUENE Inc.',
    breakdown: 'รายละเอียด',
    help: 'ความช่วยเหลือ',
    user_display_mode: {
      my_assessment: 'การประเมินของฉัน',
      supply_chain_assessment: 'การประเมินห่วงโซ่อุปทาน',
    },
    buyer: 'บริษัทผู้ซื้อ',
    supplier: 'ซัพพลายเออร์',
    error_page: {
      section_one: 'ไม่พบหน้า',
      section_two: 'โปรดตรวจสอบ URL',
      to_dashboard: 'กลับไปที่แดชบอร์ด',
    },
    priority: {
      good: 'ดี',
      high: 'สูง',
      medium: 'ปานกลาง',
      low: 'ต่ำ',
    },
    priority_full_name: {
      high: 'ความเสี่ยงสูง',
      medium: 'ความเสี่ยงปานกลาง',
      low: 'ความเสี่ยงต่ำ',
    },
    faq: {
      how_to_use_csv_head: 'หากต้องการเปิดไฟล์ CSV ที่ดาวน์โหลดมาใน Excel โปรดทำตามคำแนะนำด้านล่าง',
      how_to_use_csv_body_01: '1. เปิดสมุด Excel เปล่าใหม่',
      how_to_use_csv_body_02: "2. บนแท็บ 'ข้อมูล' ให้คลิก 'จากข้อความหรือ CSV'",
      how_to_use_csv_body_03: "3. เลือกไฟล์ CSV และคลิก 'นำเข้า'",
      how_to_use_csv_body_04: '4. ยืนยันว่าไฟล์ได้รับการนำเข้าอย่างถูกต้อง',
      how_to_use_csv_body_05: "5. เลือก 'โหลด'",
      how_to_use_csv_note: '※ ขั้นตอนอาจแตกต่างกันไปโดยขึ้นอยู่กับระบบปฏิบัติการและเวอร์ชันของ Microsoft Excel ที่ใช้',
    },
    answer_display_status: {
      unanswered: 'ยังไม่ได้เริ่มต้น',
      temporarily_saved: 'อยู่ระหว่างดำเนินการ',
      submitted: 'ส่งแล้ว',
      score_rated: 'ประเมินแล้ว',
      ended: 'ปิดแล้ว',
    },
    all: 'ทั้งหมด',
    count: {
      // question: '',
      company: ' บริษัท',
      unit: 'รายการ',
      // number_of_questions_label: '',
    },
    esg_data_display_status: {
      unanswered: '@:common.answer_display_status.unanswered',
      temporarily_saved: '@:common.answer_display_status.temporarily_saved',
      // sharing: '',
      // unshared: '',
      // inviting: '',
      // viewable: '',
      // unviewable: '',
    },
    modal: {
      csv_download_mail_sended: {
        // title: '',
        message_one: '@:list_table_filter.csv_modal_sent_mail_section_one',
        message_two: '@:list_table_filter.csv_modal_sent_mail_section_two',
        message_three: '@:list_table_filter.csv_modal_sent_mail_section_three',
      },
    },
    status: 'สถานะ',
    notification: {
      send_back: {
        // title: '',
        // description_1: '',
        // description_2: '',
        comment_label: '@:buyer_scorecard.answer_rejection_modal_text',
      },
      withdraw: {
        // title: '',
        // description_1: '',
        // description_2: '',
        // comment_label: '',
      },
      download: {
        // csv_success_title: '',
        // csv_description_1: '',
        // common_description: '',
        // action: '',
        // csv_failed_title: '',
        // failed_description_1: '',
        // failed_description_2: '',
        // pdf_success_title: '',
        // pdf_description_1: '',
        // pdf_failed_title: '',
      },
      message: {
        // title: '',
        // description: '',
      },
      company_name_label: '@:esg_data.company_name',
      message_label: '@:esg_data.message',
      data_share_invitation: {
        // title: '',
        // description: '',
        // person_label: '',
        data_label: '@:esg_data.data_name',
        // description_1: '',
        // description_2: '',
        // modal_description: '',
      },
      data_share_complete: {
        // title: '',
        // description: '',
      },
      answer_remind: {
        // title: '',
        // description: '',
      },
      // empty_description_1: '',
      // empty_description_2: '',
      // title: '',
      // unread: '',
    },
    buyer_create_question: {
      // title: '',
      // create_survey: '',
      // answer_list: '',
    },
    information: {
      // not_available: '',
      // please_wait: '',
    },
    action: {
      // delete_item: '',
    },
    category_icon: {
      // no_select: '',
      // water: '',
      // waste: '',
      // ghg: '',
      // human_rights: '',
      // occupational_safety: '',
      // security: '',
      // balance_scale: '',
      // icon: '',
      // check: '',
    },
    placeholder: {
      input_free: 'เข้าสู่',
      half_digits: 'เลขครึ่งกว้าง',
    },
  },
};
